import React, { useEffect } from "react";
import './styles/app.css'
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import MainRoutes from "./routes/routes";
import SEO from "components/SEO/SEO";
import ScrollToTop from "./ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "./redux/slices/auth.slice";
import useSocketService from "./hooks/useSocketService";

function App() {
    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.auth);

    useSocketService();

    useEffect(() => {
        if (token) {
            dispatch(fetchUserProfile());
        }
    }, [dispatch, token]);

    return (
        <>
            <SEO />
            <div className="App">
                <ScrollToTop />
                <MainRoutes />
                <ToastContainer />
            </div>
        </>
    );
}

export default App;
